import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { DwAuthService } from '../../../auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { FxUserInfoService } from 'app/implementation/auth/fx-auth/fx-user-info.service';


@Injectable()
export class DwViewLangLoaderService {
  private lastProgramId = ''; // 最後翻譯的作業編號
  private translated: any = {}; // 已翻譯清單
  private ent;

  constructor(
    private http: HttpClient,
    private authService: DwAuthService,
    private route: ActivatedRoute,
    private fxUserService: FxUserInfoService
  ) {
    route.queryParamMap.subscribe( // 路由变化执行
      params => {
        // console.log('多语言企业', this.ent);
        const DwFxed020EntInfo = sessionStorage.getItem('DwFxed020EntInfo');
        // debugger
        const now_ent = params.get('ent') || window.location.search.split('?ent=')[1] || DwFxed020EntInfo || "";
        this.ent = now_ent !== this.ent && now_ent !=='' ? now_ent : this.ent;
        if (!this.ent) {
          console.log('获取多语言企业', this.ent);
          this.getAas().subscribe((result: any) =>
            {
              this.ent = result.data[0].aas002;
              this.setEnt();
            }
          );
        } else {
          this.setEnt();
        }
      }
    );
  }
  public getAas(): Observable<any> {
    //获取系统参数
    var systemKeys = ['c_S001'];
    return this.http.post('A/IACommonService/pub_upd_aas', {
      param: systemKeys
    }).pipe(
      map(
      result => {
        return result;
      }
    ));
 }

 public setEnt() {
  if (this.ent == "") {
    return;
  }
  this.fxUserService.readEnt(this.ent).subscribe(
    data => {
      if (!data['success']) {
        // console.log(111);
        return;
      }
    }, error => {
      console.log(error);
    }
  );
}
  /**
   * 畫面翻譯檔載入器,不限已登入
   * @param lang 語系
   * @param [programId] 作業編號
   * @returns translation 畫面翻譯檔
   */
  getTranslation(lang: string, programId?: string): Observable<any> {
    // 語言別改變時會取語全部的系文檔，此時只要翻譯最後一個作業，其他的則是透過路由轉換時再翻譯
    if (!programId) {
      programId = this.lastProgramId;
    } else {
      this.lastProgramId = programId;
    }

    const isLoggedIn = this.authService.isLoggedIn; // 是否已登入
    const subject: Subject<any> = new Subject<any>();
    const transId = lang + '/' + programId;
    // 沒翻譯過才需要重新取檔案
    if (programId && this.translated[lang] === undefined || programId && this.translated[lang][programId] === undefined ) {
    // if (programId) {
      // const languageLoaderObs = this.http.get('assets/i18n/' + transId + '.json').pipe(
      //   map(
      //     (response: object) => {
      //       const langData = response;

      //       this.translated[lang] ?
      //         this.translated[lang][programId] = programId :
      //         this.translated[lang] = new Array, this.translated[lang][programId] = programId;

      //       return langData;
      //     }
      //   )
      // );
      const languageLoaderObs = this.http.post('A/IACommonService/getLanguageJsonInfoAnonymous', { param: { program_no:  programId, language: lang, ent: 12} }).pipe(
        map(
          (response: any) => {
            const langData = JSON.parse(response.data);
            if (response.success&&langData) {
            this.translated[lang] ?
              this.translated[lang][programId] = programId :
              this.translated[lang] = new Array, this.translated[lang][programId] = programId;
            }
            return langData;
          }
        )
      );
      const subscription = languageLoaderObs.subscribe(
        langData => {
          subject.next(langData);
          subject.complete();
          subscription.unsubscribe();
        },
        error => {
          subject.complete();
          subscription.unsubscribe();
        }
      );
    } else {
      subject.complete();
    }

    return subject.asObservable();
  }
}
